import { isDefined } from "@ls/js-utils";
import SummaryType from "state/selections/Constants/SummaryType";
import scope from "./scope";

export default class BookAnalyticDefinition {
  static getDefault = () =>
    new BookAnalyticDefinition({
      bookAnalytic: "amortBookGSpread",
      basis: "gaap",
      summary: SummaryType.ABSOLUTE,
    });

  #bookAnalytic;
  #basis;
  #summary;

  constructor({ bookAnalytic, basis, summary }) {
    this.#bookAnalytic = bookAnalytic;
    this.#basis = basis;
    this.#summary = summary;
  }

  get bookAnalytic() {
    return this.#bookAnalytic;
  }
  get basis() {
    return this.#basis;
  }
  get summary() {
    return this.#summary;
  }
  get complete() {
    return (
      isDefined(this.bookAnalytic) &&
      isDefined(this.basis) &&
      isDefined(this.summary)
    );
  }
  get key() {
    return `${scope} - ${this.bookAnalytic}, ${this.basis}, ${this.summary}`;
  }

  setBookAnalytic = (value) =>
    new BookAnalyticDefinition({
      ...this.copy(),
      bookAnalytic: value,
    });
  setBasis = (value) =>
    new BookAnalyticDefinition({
      ...this.copy(),
      basis: value,
    });

  setSummary = (value) =>
    new BookAnalyticDefinition({
      ...this.copy(),
      summary: value,
    });

  copy = () => {
    return {
      bookAnalytic: this.bookAnalytic,
      basis: this.basis,
      summary: this.summary,
    };
  };
}
